const HiddenViewContainer = ({show, children}) => {
    return(
        <>
            {show === true ? children : <></>}
        </>    
    );
}

export default HiddenViewContainer;